module.exports = __webpack_public_path__ + "img/public/AdminIcons/whistListGoIcon.svg?4e5c3925";